export default __webpack_public_path__ + "fde48e4609a6ddc11d639fc2421f2afd.png";